<!-- Adapted from YesPlayMusic v0.4.11 views/mv.vue, MIT, qier222. MV transport is explicitly unavailable. -->
<template>
  <section v-if="salt" class="salt-mv-page"><h1>音乐视频</h1><SaltCard><SaltItem title="音乐视频暂不可用" description="此来源未提供 MV 播放接口。" /><SaltItem title="返回音乐库" clickable arrow="arrow" @click="$router.push('/library')" /></SaltCard></section>
  <div v-else class="mv-page">
    <div class="current-video">
      <div class="video"><video class="plyr" aria-label="MV 播放器" /></div>
      <div class="video-info"><div class="title">音乐视频</div><div class="info">此来源未提供 MV 播放接口。</div></div>
    </div>
    <div class="more-video"><div class="section-title">更多视频</div><MvRow :mvs="[]" /></div>
    <router-link class="plain-button" to="/library">返回音乐库</router-link>
  </div>
</template>
<script>
import MvRow from '../components/MvRow.vue';
import { workspace } from '../workspace';
import SaltCard from '../salt/ui/SaltCard.vue';
import SaltItem from '../salt/ui/SaltItem.vue';
export default {name:'Mv',components:{MvRow,SaltCard,SaltItem},data(){return {workspace}},computed:{salt(){return this.workspace.appearance==='salt';}}};
</script>
<style lang="scss" scoped>
.salt-mv-page h1 { margin:0 0 20px;font-size:24px;font-weight:400;color:var(--salt-text); }
.video {
  --plyr-color-main: #335eea;
  --plyr-control-radius: 8px;
}

.mv-page {
  width: 100%;
  margin-top: 32px;
}
.current-video {
  width: 100%;
}
.video {
  border-radius: 16px;
  background: transparent;
  overflow: hidden;
  max-height: 100vh;
}

.video-info {
  margin-top: 12px;
  color: var(--color-text);
  .title {
    font-size: 24px;
    font-weight: 600;
  }
  .artist {
    font-size: 14px;
    opacity: 0.88;
    margin-top: 2px;
    font-weight: 600;
  }
  .info {
    font-size: 12px;
    opacity: 0.68;
    margin-top: 12px;
  }
}

.more-video {
  margin-top: 48px;
  .section-title {
    font-size: 18px;
    font-weight: 600;
    color: var(--color-text);
    opacity: 0.88;
    margin-bottom: 12px;
  }
}

.buttons {
  display: inline-block;
  .button {
    display: inline-block;
  }
  .svg-icon {
    height: 18px;
    width: 18px;
    color: var(--color-primary);
  }
}
</style>
